type UnitApplyProperty = {
  id?: string | null;
  affordableHousing?: boolean | null;
} | null;

type BuildUnitApplyPathInput = {
  property?: UnitApplyProperty;
  fallbackPropertyId?: string | null;
  unitID: string;
  moveInDate: string;
  leaseTerm: string | number;
};

export const buildUnitApplyPath = ({
  property,
  fallbackPropertyId,
  unitID,
  moveInDate,
  leaseTerm,
}: BuildUnitApplyPathInput) => {
  const params = new URLSearchParams({
    propertyId: property?.id || fallbackPropertyId || "",
    unitID,
    moveInDate,
    leaseTerm: String(leaseTerm),
  });

  const route =
    property?.affordableHousing === true
      ? "/application/affordable/prequalify"
      : "/application/register";

  return `${route}?${params.toString()}`;
};
